import getUUID from './uuid'

export const getUserId = () => localStorage['__app__sgcs__userId__']
export const setUserId = (value: string) => {
  localStorage['__app__sgcs__userId__'] = value
}

export const getOrderNo = () => sessionStorage['__app__sgcs__orderNo__']
export const setOrderNo = (value: string) => {
  sessionStorage['__app__sgcs__orderNo__'] = value
}

export const getIQStartTime = () => sessionStorage['__app__sgcs__start__time__']
export const setIQStartTime = (value: string) => {
  sessionStorage['__app__sgcs__start__time__'] = value
}

export const setStorageUUID = (value: string) => {
  localStorage['__app__sgcs__uuid__'] = value
}

export const getStorageUUID = () => {
  let ls = localStorage['__app__sgcs__uuid__']
  if (!ls) {
    ls = getUUID()
    setStorageUUID(ls)
  }

  return ls
}
